export default __webpack_public_path__ + "static/media/add_icon.61ea9749.svg";